import { winners } from "../common/constants";
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

function TopWinners() {

    return (
        <div className="container top-winners">
            <div className="section-heading-branded">
                <span className="section-heading-branded__star" aria-hidden="true">⭐</span>
                <h2 className="section-heading-branded__text mb-0">Today&apos;s Top Winners</h2>
                <span className="section-heading-branded__star" aria-hidden="true">⭐</span>
            </div>
            <Swiper
                loop={true}
                spaceBetween={20}
                centeredSlides={true}
                autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                }}
                speed={3000}
                // navigation={true}
                slidesPerView={"auto"}
                modules={[Autoplay]}
                className="mySwiper"
            >
                {
                    winners.map((winner, index) => {
                        return <SwiperSlide key={index}>
                                <h3 className="winner-card__name">
                                    <span className="winner-card__trophy" aria-hidden="true">🏆</span>
                                    {winner.name}
                                </h3>
                                <p className="winner-card__amount">
                                    <span className="winner-card__rupee">₹</span>
                                    {winner.amount}/-
                                </p>
                        </SwiperSlide>
                    })
                }
            </Swiper>
        </div>
    );
}

export default TopWinners;